import {
  UserFilterStatus,
  type UserFromRequest,
  type UserManagementFilter,
} from "../../userManagement.types";
import type { User } from "./userList.types";

export function toUser(
  userFromRequest: UserFromRequest,
  clientId: number | null
): User {
  const isActiveForClient = userFromRequest.clientes.find(
    (item) => item.idCliente === clientId
  )?.ativo;

  return {
    email: userFromRequest.email,
    id: userFromRequest.idUsuario,
    isActiveForClient: isActiveForClient || false,
    login: userFromRequest.login,
    name: userFromRequest.nome,
    farms: userFromRequest.fazendas.map((f) => f.nome),
    retreats: userFromRequest.retiros.map((r) => r.nome),
    permissions: userFromRequest.permissoes.map((p) => p.nome),
  };
}

export function toUserManagementFilter<
  T extends { userManagementFilter?: UserManagementFilter | null } | null
>(filter: T): UserManagementFilter {
  if (filter?.userManagementFilter == null) {
    return {
      farmIds: [],
      permissions: [],
      retreatIds: [],
      searchValue: "",
      status: null,
    };
  }

  return {
    farmIds: filter.userManagementFilter.farmIds,
    permissions: filter.userManagementFilter.permissions,
    retreatIds: filter.userManagementFilter.retreatIds,
    searchValue: filter.userManagementFilter.searchValue,
    status: filter.userManagementFilter.status,
  };
}

export function isManagementFilterEmpty(
  filter?: UserManagementFilter | null
): filter is UserManagementFilter {
  if (filter == null) {
    return false;
  }

  return (
    filter.farmIds.length === 0 &&
    filter.permissions.length === 0 &&
    filter.retreatIds.length === 0 &&
    filter.searchValue === "" &&
    (filter.status === null || filter.status === UserFilterStatus.All)
  );
}

export enum UserListColumns {
  Name = "name",
  Login = "login",
  Email = "email",
  Farms = "farms",
  Retreats = "retreats",
  Permissions = "permissions",
  Status = "status",
  Actions = "actions",
}
